import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule, ModalModule, TimepickerModule } from 'ngx-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

// import { ServiceCallDisplayIdModule, DisplayIdModule } from '../../../directives';
import { DisplayIdModule, PMStatusNum2StatusNameModule } from '../../../directives';

import { ServiceCallRoutingModule } from './service-call-routing.module';
import { ServiceCallSummaryComponent, ServiceCallSummaryService } from './service-call-summary';
import { ServiceCallDetailComponent, ServiceCallDetailService,
  ServiceCallEquipmentSummaryComponent, ServiceCallEquipmentSummaryService, ServiceCallCancelService } from './service-call-detail';
import { ServiceCallCreateComponent, ServiceCallCreateService } from './service-call-create';
import { ServiceCallEditComponent, ServiceCallEditService } from './service-call-edit';
import { ServiceCallPdfAddComponent } from './service-call-pdf-add/service-call-pdf-add.component';
import { ServiceCallPdfSummaryComponent } from './service-call-pdf-summary/service-call-pdf-summary.component';
import { ServiceCallService } from './service-call.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    ReactiveFormsModule,
    SharedModule,
    ServiceCallRoutingModule,
    // ServiceCallDisplayIdModule,
    DisplayIdModule,
    PMStatusNum2StatusNameModule,
    SelectModule,
    AngularMultiSelectModule,
    NgbModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    ServiceCallSummaryComponent,
    ServiceCallDetailComponent,
    ServiceCallEquipmentSummaryComponent,
    ServiceCallCreateComponent,
    ServiceCallEditComponent,
    ServiceCallPdfAddComponent,
    ServiceCallPdfSummaryComponent,
  ],
  providers: [
    ServiceCallSummaryService,
    ServiceCallDetailService,
    ServiceCallEditService,
    ServiceCallCreateService,
    ServiceCallEquipmentSummaryService,
    ServiceCallCancelService,
    ServiceCallService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ]
})
export class ServiceCallModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call.module.ts